import { Sparkles } from "lucide-react";
import { openAssistant } from "../../lib/assistantApi";

export function HelpChooseButton({ context, testid, className = "" }) {
  return (
    <button type="button" data-testid={testid} onClick={() => openAssistant(context)}
      className={`inline-flex min-h-[44px] items-center gap-2 rounded-full border border-[var(--brand-primary)]/20 bg-white px-4 text-sm font-semibold text-[var(--brand-primary)] transition-colors hover:bg-[var(--brand-primary-tint)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-focus)] ${className}`}>
      <Sparkles size={16} aria-hidden="true" /> Ask Rhyte AI
    </button>
  );
}
